// extracted by mini-css-extract-plugin
export default {"icons":"UserNav_icons__VnrN+","navUl":"UserNav_navUl__B3iwc","nav":"UserNav_nav__B+zb1","active":"UserNav_active__dbIz6"};